import { createApp } from 'vue';
import { createWebHashHistory, createRouter } from 'vue-router';

import App from './App.vue';

import NotFound from './routes/NotFound.vue';
import Sleep from './routes/Sleep.vue';
import Stress from './routes/Stress.vue';
import Live from './routes/Live.vue';
import Diet from './routes/Diet.vue';
import Beauty from './routes/Beauty.vue';
import Supplements from './routes/Supplements.vue';
import Age from './routes/Age.vue';
import EmailOptIn from './routes/EmailOptIn.vue';
import Results from './routes/Results.vue';

export default class Quiz {
    constructor (el) {
        if (!el) return;

        this.config = Object.assign(JSON.parse(document.getElementById('quizConfig').text), { navigation: { secondary: false } });
        const globalEls = document.querySelectorAll('.js-quiz-global-els');
        const templateEls = document.querySelector('.js-quiz-template-els-container');

        this.routes = [
            {
                path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound,
                meta: {
                    title: this.config.translations.pages.notFound.heading
                }
            },
            {
                path: '/',
                component: Sleep,
                name: 'Sleep'
            },
            {
                path: '/:sleep',
                component: Stress,
                name: 'Stress',
                meta: {
                    back: 'Sleep'
                }
            },
            {
                path: '/:sleep/:stress/',
                component: Live,
                name: 'Live',
                meta: {
                    back: 'Stress'
                }
            },
            {
                path: '/:sleep/:stress/:live/',
                component: Diet,
                name: 'Diet',
                meta: {
                    back: 'Live'
                }
            },
            {
                path: '/:sleep/:stress/:live/:diet/',
                component: Beauty,
                name: 'Beauty',
                meta: {
                    back: 'Diet'
                }
            },
            {
                path: '/:sleep/:stress/:live/:diet/:beauty',
                component: Supplements,
                name: 'Supplements',
                meta: {
                    back: 'Beauty'
                }
            },
            {
                path: '/:sleep/:stress/:live/:diet/:beauty/:supplements',
                component: Age,
                name: 'Age',
                meta: {
                    back: 'Supplements'
                }
            },
            {
                path: '/:sleep/:stress/:live/:diet/:beauty/:supplements/:age',
                component: EmailOptIn,
                name: 'EmailOptIn',
                meta: {
                    back: 'Age'
                }
            },
            {
                path: '/:sleep/:stress/:live/:diet/:beauty/:supplements/:age/:emailOptIn/results',
                component: Results,
                name: 'Results'
            }
        ];

        this.router = createRouter ({
            history: createWebHashHistory(),
            routes: this.routes,
            scrollBehavior(to, from, savedPosition) {
                if (savedPosition) {
                    return savedPosition;
                } else {
                    return { top: 0 }
                }
            }
        });

        this.router.afterEach((to) => {
            if (to.name !== 'Results' && window.innerWidth >= 1024) {
                document.querySelector('.js-route-content-container')?.scrollTo(0, 0);
            }

            if (to.name === 'Results') {
                globalEls.forEach(element => {
                    element.classList.remove('!hidden');
                });
                templateEls.classList.remove('hide-quiz-template-els');
            } else {
                globalEls.forEach(element => {
                    element.classList.add('!hidden');
                });
                templateEls.classList.add('hide-quiz-template-els');
            }
        });

        // Updates page `<title>`
        const rootTitle = document.title;

        if (rootTitle) {
            this.router.afterEach(to => {
                document.title = to.meta?.title ? `${to.meta.title} - ${rootTitle}` : rootTitle;
            });
        }

        this.init();
    }

    init() {
        createApp(App)
            .use(this.router)
            .mount('#app-quiz');
    }
}
